import type { ReactNode } from "react";

export function Panel({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <section className={`panel p-4 ${className}`}>{children}</section>;
}

export function BlazeMark({ solid = false }: { className?: string; solid?: boolean }) {
  return <span aria-hidden="true" className={solid ? "trail-blaze-solid" : "trail-blaze"} />;
}

/** Small white-over-red trail-blaze app mark. */
export function AppLogo({ size = 40 }: { size?: number }) {
  return (
    <span
      aria-hidden="true"
      className="trail-blaze-solid"
      style={{ width: Math.round(size * 0.6), height: size, borderRadius: 4 }}
    />
  );
}
